<template>
  <b-modal id="futurefeatures" title="sci-fund / Explore research funding opportunities" size="md" ok-only ok-title="Close">
    <h4 class="mt-3">sci-fund EU</h4>
    <p>This is the sci-fund EU platform which provides intelligent search, semantic discovery, and visual exploration of European funding opportunities. It contains most calls from the last H2020 work programmes (2018-2020) as well as draft versions of Horizon Europe.</p>

    <h4 class="mt-5">Features</h4>
    <ul>
      <li>Access to current and forthcoming funding opportunities</li>
      <li>Sophisticated search with semantic features</li>
      <li>Visual exploration of the knowledge graph</li>
      <li>Search history and saved searches</li>
      <li>Search alerts</li>
      <li>Exporting search results to PDF</li>
      <li>Sharing search results per email</li>
      <li>Access to infographics</li>
      <li>and more</li>
    </ul>
    <p><a href="https://www.sci-fund.ai" target="_blank">Find out more</a>  about sci-fund’s features on our website.</p>

    <p>Are you ready to subscribe? Choose a <a href="https://www.sci-fund.ai/plans-and-prices" target="_blank">fitting plan</a> for you or your organization! Or get your <a href="https://www.sci-fund.ai/trial-registration" target="_blank">free trial account</a> today! </p>

    <h4 class="mt-5">Additional packages available on request for</h4>
    <ul>
      <li>Custom organization-specific templates for exporting and sharing results</li>
      <li>Additional options for exporting into editable formats (e.g., MS Word)</li>
      <li>Custom organization-specific branding and sci-fund subdomain (e.g., your-org.sci-fund.ai)</li>
      <li>Additional sources (such as national funding schemes)</li>
      <li>and much more</li>
    </ul>

    <p>For feedback, questions and comments, please contact us at <a href="mailto:info@sci-fund.ai">info@sci-fund.ai</a>.</p>


  </b-modal>
</template>

<script>
export default {
  name: 'FutureFeatures',
  computed: {

  }

}
</script>

<style scoped>

</style>
